<template>
  <div>
    <section>
      <scroll-container
        class="pt-2 mt-n40px"
        height-offset="140px"
      >
        <b-skeleton
          v-if="isLoading"
          animation="wave"
          class="adDebugger-card mt-2"
        />
        <b-card
          v-else
          class="adDebugger-card mt-2"
          no-body
        >
          <div class="mx-2 my-2">
            <b-form-group
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Property')"
            >
              <multiselect
                v-model="selectedModel.property"
                :options="adDebugger.properties"
                :close-on-select="true"
                label="name"
                track-by="id"
                :show-labels="false"
                @select="resetSelectedFields"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectProperty') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              v-if="selectedModel.property"
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Placement')"
            >
              <multiselect
                v-model="selectedModel.placement"
                :options="adDebugger.properties.find(property => property.id === selectedModel.property.id).placements"
                :close-on-select="true"
                label="name"
                track-by="id"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectPlacement') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Browser')"
            >
              <multiselect
                v-model="selectedModel.browser"
                :options="adDebugger.browsers"
                :close-on-select="true"
                label="text"
                track-by="text"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectBrowser') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Country')"
            >
              <multiselect
                v-model="selectedModel.country"
                :options="adDebugger.countries"
                :close-on-select="true"
                label="text"
                track-by="value"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectCountry') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Platform')"
            >
              <multiselect
                v-model="selectedModel.platform"
                :options="adDebugger.platforms"
                :close-on-select="true"
                label="text"
                track-by="text"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectPlatform') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              label-for="devices"
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.Device')"
            >
              <multiselect
                v-model="selectedModel.device"
                :options="adDebugger.devices"
                :close-on-select="true"
                label="text"
                track-by="text"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectProperty') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group
              label-cols="6"
              :label="$tk('ClientPortal.Admin.AdDebugger.OS')"
            >
              <multiselect
                v-model="selectedModel.os"
                :options="adDebugger.oSs"
                :close-on-select="true"
                label="text"
                track-by="text"
                :show-labels="false"
              >
                <template slot="placeholder">
                  <span class="mb-0">{{ $tk('Admin.AdDebugger.SelectOS') }}</span>
                </template>
                <template
                  slot="caret"
                  slot-scope="{ toggle }"
                >
                  <div
                    class="multiselect__select"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <GjIcon
                      class="icon-wrapper"
                      name="ArrowDown_fill"
                      size="21"
                    />
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </div>
        </b-card>
      </scroll-container>
      <div
        class="border-top text-right py-1"
      >
        <b-button
          v-b-modal.modal-debug
          size="sm"
          variant="primary"
          :disabled="isLoading"
          @click="debug"
        >
          {{ $tk('ClientPortal.Admin.AdDebugger.Debug') }}
        </b-button>
      </div>
    </section>
    <b-modal
      id="modal-debug"
      centered
      size="md"
      :title="$tk('ClientPortal.Admin.AdDebugger.Preview')"
      :hide-header="!selectedModel.adCalled"
      hide-footer
      class="modal-body--no-footer"
      no-enforce-focus
    >
      <b-spinner
        v-if="!selectedModel.adError && !selectedModel.adCalled"
        class="d-flex mx-auto"
        variant="primary"
      />
      <div
        v-show="selectedModel.adCalled"
      >
        <div
          id="ap-debug-body"
          class="card-body"
        >
          <div
            id="ap-debug-div"
          />
        </div>
      </div>
      <div
        v-show="selectedModel.adError"
      >
        <div class="text-center my-2">
          <span>{{ selectedModel.errorMessage }}</span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import translation from '@/mixins/translate'
import ScrollContainer from '@/components/ScrollContainer.vue'
import Multiselect from 'vue-multiselect'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    ScrollContainer,
    Multiselect,
    GjIcon,
  },

  setup() {
    const adDebuggerColumns = [{
      label: translation.methods.$tk('ClientPortal.Admin.AdDebugger.Title'),
      field: 'title',
    },
    {
      label: translation.methods.$tk('ClientPortal.Admin.AdDebugger.Value'),
      field: 'value',
    },
    ]
    const selectedModel = ref({
      browser: '',
      country: '',
      platform: '',
      device: '',
      os: '',
      audience: '',
      property: '',
      placement: '',
      adCalled: 0,
      adError: 0,
      errorMessage: '',
    })
    const constants = {
      serveUrl: 'central.gjirafa.dev',
      noAdsMessage: translation.methods.$tk('ClientPortal.Admin.AdDebugger.ThereAreNoAdsForThisSpecificRequest'),
      propertyIdError: translation.methods.$tk('ClientPortal.Admin.AdDebugger.YouHaveToSelectAProperty'),
      placementIdError: translation.methods.$tk('ClientPortal.Admin.AdDebugger.YouHaveToSelectAPlacement'),
    }
    const adDebugger = computed(() => store.getters.getAdDebugger)
    const isLoading = ref(true)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getAdDebugger')
      const gjanoutScript = document.createElement('script')
      gjanoutScript.setAttribute('src', `${process.env.VUE_APP_CENTRAL_API_URL || 'https://central.gjirafa.com'}/js/ap-gjanout.js`)
      document.head.appendChild(gjanoutScript)
      isLoading.value = false
    })

    const loadAd = (propertyId, placementId) => {
      window.ANConfig = window.ANConfig || {}
      window.ANConfig.placements = window.ANConfig.placements || []

      window.ANConfig.placements.push({
        adUnitId: 'ap-debug-div',
        propertyId,
        placementId,
        content: [],
        onLoad(adUnitId) {
          selectedModel.value.adCalled = 1
          console.log('1', adUnitId)
        },
        onFail(adUnitId) {
          selectedModel.value.errorMessage = constants.noAdsMessage
          selectedModel.value.adError = 1
          console.log('0', adUnitId)
          // fallback code
        },
      })
    }

    const debug = () => {
      selectedModel.value.adCalled = 0
      selectedModel.value.adError = 0
      if (!selectedModel.value.property.id || !selectedModel.value.placement.id) {
        if (!selectedModel.value.property.id) {
          selectedModel.value.errorMessage = constants.propertyIdError
          selectedModel.value.adError = 1
          return
        }
        if (!selectedModel.value.placement.id) {
          selectedModel.value.errorMessage = constants.placementIdError
          selectedModel.value.adError = 1
          return
        }
      }
      if (selectedModel.value.browser.text !== '') {
        constants.serveUrl = `${constants.serveUrl}?&browser=${selectedModel.value.browser.text}`
      }
      if (selectedModel.value.country.value !== null && selectedModel.value.country.value !== '') {
        constants.serveUrl = `${constants.serveUrl}?&country=${selectedModel.value.country.value}`
      }
      if (selectedModel.value.platform.text !== '') {
        constants.serveUrl = `${constants.serveUrl}?&platform=${selectedModel.value.platform.text}`
      }
      if (selectedModel.value.device.text !== '') {
        constants.serveUrl = `${constants.serveUrl}?&device=${selectedModel.value.device.text}`
      }
      if (selectedModel.value.os.text !== '') {
        constants.serveUrl = `${constants.serveUrl}?&os=${selectedModel.value.os.text}`
      }
      constants.serveUrl = '&token=Jws3y8J_ZQNdXsVPe2hnrckqVc5CGz'
      constants.serveUrl = encodeURI(constants.serveUrl)
      console.log(constants.serveUrl)
      loadAd(selectedModel.value.property.id, selectedModel.value.placement.id)
    }

    const resetSelectedFields = () => {
      selectedModel.value = {
        ...selectedModel.value,
        browser: '',
        country: '',
        platform: '',
        device: '',
        os: '',
        audience: '',
        placement: '',
        adCalled: 0,
        adError: 0,
        errorMessage: '',
      }
    }

    return {
      selectedModel,
      adDebugger,
      isLoading,
      adDebuggerColumns,
      debug,
      resetSelectedFields,
    }
  },
}
</script>
<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
.adDebugger-card{
    height: calc(100vh - 212px) ;
    overflow-y: auto;
  }
div#ap-debug-body.card-body{
  max-height: 500px;
  overflow: auto;
}
</style>
